import React from "react";
import Grid from "@material-ui/core/Grid";
import '../../../../App.scss';
import SpecialDiscountTreasure from "../../../../assets/images/speacialDiscountTreasure.png";
import BlackButton from "../../Settings/Free/BlackButton";
import GoldCoin from "../../../../assets/images/ic_coin.png";

class GiftHallOffer extends React.Component{
    constructor(props){
        super(props)
    }
    render() {

        const {bannerActive, bannerUrl, fullPrice, giftVal, hallName, icon, id, isVisible, name, price, qIcon, quantity, sessonNumber, shopIcon, shopText, type, typeDesc}=this.props.data
        const {
            TOM,
            golden,
            rollvip,
            silver,
        }=this.props.reward

        const blackButton={
            backgroundColor:'white',
            textColor:'black',
            text:golden,
            bottomFontSize:'20px',
            icon:GoldCoin,
            borderColor:'transparent'
        }
        return(
            <Grid className='gift-hall-offer-outer'>
                <Grid container className='gift-hall-offer-outer-inner'>
                    <Grid direction={"row-reverse"} container justify={"space-between"} alignItems={"center"} sm={12} xs={12}>
                        <Grid container xs={5} sm={5} justify={"center"} alignItems={"center"}>
                            <img src={shopIcon} className='gift-hall-offer-outer-inner-badge' alt=""/>
                        </Grid>
                        <Grid  direction={"column"} justify={"center"} alignItems={"center"} container xs={5} sm={5}>
                            <Grid>
                                <p className='gift-hall-offer-outer-inner-season-text'>
                                    جوایز این فصل
                                </p>
                            </Grid>
                            <Grid container alignItems={"center"} justify={"center"} sm={5} xs={5} style={{height:'50px'}}>
                                <BlackButton data={blackButton}/>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid direction={"row-reverse"} container justify={"space-between"} alignItems={"center"} sm={12} xs={12}>
                        <Grid container justify={"flex-end"} xs={5} sm={5}>
                            <p className='gift-hall-offer-outer-inner-title'>
                                {hallName}
                                {/*<sup>*/}
                                {/*    فصل هشتم*/}
                                {/*</sup>*/}
                            </p>
                        </Grid>
                        {/*<Grid alignItems={"center"} justify={"space-between"} style={{height:'50px',position:'relative'}} container xs={5} sm={5}>*/}
                        {/*    <Grid style={{height:'50px'}} alignItems={"center"} justify={"center"} container xs={5} sm={5}>*/}
                        {/*        <BlackButton data={blackButton}/>*/}
                        {/*    </Grid>*/}
                        {/*    <Grid style={{height:'50px'}} alignItems={"center"} justify={"center"} container xs={5} sm={5}>*/}
                        {/*        <BlackButton data={blackButton}/>*/}
                        {/*    </Grid>*/}
                        {/*</Grid>*/}
                    </Grid>
                    <Grid className='gift-hall-offer-outer-inner-textbox'>
                        <p>
                            {shopText}
                        </p>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}
export default GiftHallOffer